export * from './mainContent';
